export interface UserFeedback {
    summary: string;
    description: string;
    isUrgent: boolean;
    fileData?: File;
    srcPage?: string;
}
